import styled from "styled-components";

export const Container = styled.div``;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;

    overflow-y: auto;
    max-height: 300px;
`;

export const Title = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-weight: 500;

`;

export const ContentInfor = styled.div`
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_50};
`;

export const Subtitle = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_500};
    font-size: 14px;
`;

export const Description = styled.span`
    color: ${(props) => props.theme.colors.gray.gray_800};
`;

export const SeparateDiv = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    width: 100%;
`;

export const FormInput = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    input{
        &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
        border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
        padding: 10px;
        width: 100%;
    }
`;

export const Label = styled.label`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-size: 14px;
    
    span{
        color: ${(props) => props.theme.colors.primary};
        margin-left: 3px;
    }
`;

export const Input = styled.input`
    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;
`;

export const InforErro = styled.div`
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
`;

export const Select = styled.select`
    background-color: transparent;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;
`;

export const listButton = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
export const Button = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;

    background-color: transparent;
    border: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    
    width: 100%;
    padding: 10px;
    border-radius: 4px;
    
    &.active{
        background-color: ${(props) => props.theme.colors.gray.gray_50};
        border: 1px solid ${(props) => props.theme.colors.gray.gray_200};
        font-weight: 500;
    }
    
    &:hover{
        background-color: ${(props) => props.theme.colors.gray.gray_50};
        border: 1px solid ${(props) => props.theme.colors.gray.gray_200};
    }
`;
export const Infor = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
`;
export const TitleButton = styled.p``;

export const highliInfor = styled.p<{ isActive: boolean }>`
    background-color: ${(props) => props.isActive ? 'rgba(36, 186, 91, 0.15)' : props.theme.colors.gray.gray_50};
    color: ${(props) => props.isActive ? props.theme.colors.success : props.theme.colors.gray.gray_500};
    border-radius: 4px;
    padding: 3px;
`;

export const Footer = styled.footer``;